export enum ErrorMessageActionTypes {
  SIGN_IN_FAILURE = '@@errors/SIGN_IN_FAILURE',
  CLEAR_ERROR_MESSAGES = '@@errors/CLEAR_ERROR_MESSAGES',
  ADDING_NEW_USER_FAILED = '@@errors/ADDING_NEW_USER_FAILED',
  RESETING_PASSWORD_FAILED = '@@errors/RESETING_PASSWORD_FAILED',
  NO_ACCESS = '@@errors/NO_ACCESS',
  CANT_DELETE_ADMIN = '@@errors/CANT_DELETE_ADMIN',
  SIGN_UP_FAILURE = '@@errors/SIGN_UP_FAILURE',
  EMAIL_ALREADY_EXIST='@@errors/EMAIL_ALREADY_EXIST'
} 